<template>
  <v-card class="elevation-0 mt-3" style="background-color: #fff !important">
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex :key="item.name" sm4 v-for="(item, index) in statistics" xs6>
            <v-hover>
              <v-card
                :class="`elevation-${hover ? 6 : 2} stat-${index}`"
                @click="$router.push(item.to)"
                class="task"
                slot-scope="{ hover }"
              >
                <v-responsive :aspect-ratio="1" @click="$router.push(item.to)">
                  <v-card-title>
                    <div>
                      <div class="value">{{ item.value }}</div>
                      <div class="name">{{ item.name }}</div>
                    </div>
                  </v-card-title>
                </v-responsive>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      statistics: [
        {
          name: '見積待ち',
          value: 0,
          to: {
            name: 'B0200',
            params: {
              username: this.$store.getters.user.userAccountId,
            },
          },
        },
        {
          name: 'S/A 確定待ち',
          value: 0,
          to: {
            name: 'B0400',
            params: {
              username: this.$store.getters.user.userAccountId,
              status: 'SA一時保存',
            },
          },
        },
        {
          name: '納入指示依頼未送信',
          value: 0,
          to: {
            name: 'B0500',
            params: {
              username: this.$store.getters.user.userAccountId,
              status: 'SA登録済',
            },
          },
        },
        {
          name: '納入指示待ち',
          value: 0,
          to: {
            name: 'B0600',
            params: {
              username: this.$store.getters.user.userAccountId,
              status: '指示Mail送信済',
            },
          },
        },
        {
          name: '受入確認待ち',
          value: 0,
          to: {
            name: 'B0700',
            params: {
              username: this.$store.getters.user.userAccountId,
              status: '納入指示済',
            },
          },
        },
        {
          name: 'D/O確定待ち',
          value: 0,
          to: {
            name: 'B0800',
            params: {
              username: this.$store.getters.user.userAccountId,
              status: 'DO確定済',
            },
          },
        },
      ],
    }
  },
  methods: {},
  mounted() {
    this.$http.get('/statistics').then((res) => {
      this.statistics[0].value = res.data.B0200
      this.statistics[1].value = res.data.B0400
      this.statistics[2].value = res.data.B0500
      this.statistics[3].value = res.data.B0600
      this.statistics[4].value = res.data.B0700
      this.statistics[5].value = res.data.B0800
    })
  },
}
</script>

<style scoped>
.task {
  cursor: pointer;
}
.sub-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.stat-0 {
  background: transparent url('../../assets/img/home/color/0.png') no-repeat
    100% 100%;
  color: rgba(220, 147, 137, 0.5);
  border: 3px solid rgba(220, 147, 137, 0.5);
}
.stat-1 {
  background: transparent url('../../assets/img/home/color/1.png') no-repeat
    100% 100%;
  color: rgba(128, 138, 153, 0.5);
  border: 3px solid rgba(128, 138, 153, 0.5);
}
.stat-2 {
  background: transparent url('../../assets/img/home/color/2.png') no-repeat
    100% 100%;
  color: rgba(171, 178, 164, 0.5);
  border: 3px solid rgba(171, 178, 164, 0.5);
}
.stat-3 {
  background: transparent url('../../assets/img/home/color/3.png') no-repeat
    100% 100%;
  color: rgba(219, 203, 148, 0.5);
  border: 3px solid rgba(219, 203, 148, 0.5);
}
.stat-4 {
  background: transparent url('../../assets/img/home/color/4.png') no-repeat
    100% 100%;
  color: rgba(150, 183, 213, 0.5);
  border: 3px solid rgba(150, 183, 213, 0.5);
}
.stat-5 {
  background: transparent url('../../assets/img/home/color/5.png') no-repeat
    100% 100%;
  color: rgba(198, 186, 200, 0.5);
  border: 3px solid rgba(198, 186, 200, 0.5);
}

.value {
  font-size: 48px;
  line-height: 48px;
  font-family: Impact;
}

.stat-0 .value {
  border-bottom: 1px solid rgba(220, 147, 137, 0.7);
}
.stat-1 .value {
  border-bottom: 1px solid rgba(128, 138, 153, 0.7);
}
.stat-2 .value {
  border-bottom: 1px solid rgba(171, 178, 164, 0.7);
}
.stat-3 .value {
  border-bottom: 1px solid rgba(219, 203, 148, 0.7);
}
.stat-4 .value {
  border-bottom: 1px solid rgba(150, 183, 213, 0.7);
}
.stat-5 .value {
  border-bottom: 1px solid rgba(198, 186, 200, 0.7);
}
</style>
